import axios from 'axios';
import config from '../../config';

const API = `${config.API_BASE_URL}/sales-orders`;

export const fetchSalesOrders = (queryParams = '') => axios.get(`${API}${queryParams}`);
export const createSalesOrder = (data) => axios.post(API, data);
export const loadSalesOrder = (id) => axios.put(`${API}/load/${id}`);
export const deliverSalesOrder = (id, data) => axios.put(`${API}/deliver/${id}`, data);
